import { graphHooks } from '@tunasong/graph-lib/react'
import { EntityFilters } from '@tunasong/models'
import { useCurrentUser } from '@tunasong/redux'
import type { Entity, Persisted } from '@tunasong/schemas'
import { isFolderContainer } from '@tunasong/schemas'
import { useSearch } from '@tunasong/search'

/**
 * Home's top level (docs/ux/2026-10-16-home-dashboard-redesign-ux.md), also the Move picker's (#2543): spaces are
 * the top-level folder containers, owned or shared with me; Unfiled is the rest of my top level.
 */
export const homeSpaces = ({ owned, shared }: { owned: Persisted<Entity>[]; shared: Persisted<Entity>[] }) => {
  // Shared results whose parent is also shared are reached through that parent, and owned ones are listed already
  const sharedIds = new Set(shared.map(r => r.id))
  const ownedIds = new Set(owned.map(r => r.id))
  const sharedTop = shared
    .filter(r => (r.parentId ? !sharedIds.has(r.parentId) : true))
    .filter(r => !ownedIds.has(r.id))

  const spaces = [...owned, ...sharedTop].filter(e => !e.parentId || e.parentId === 'ROOT').filter(isFolderContainer)
  const spaceIds = new Set(spaces.map(s => s.id))
  const unfiled = owned.filter(e => !spaceIds.has(e.id))
  return { spaces, unfiled }
}

export const useHomeSpaces = () => {
  const { userId } = useCurrentUser()
  const { results: shared, searching } = useSearch({ queryType: 'shared', query: userId, size: 500 })
  const { entities: owned, isLoading } = graphHooks.useEntities({ root: true, filter: EntityFilters.folder })
  return { ...homeSpaces({ owned, shared }), loading: isLoading || searching }
}
